<template>
  <div>
    <el-table :data="tableData" v-loading="tableLoading">
      <el-table-column prop="ArtType" label="类型">
        <template slot-scope="scope">{{ scope.row.ChannelType | handleType }}</template>
      </el-table-column>
      <el-table-column prop="ChannelName" label="发送渠道"></el-table-column>
      <el-table-column prop="Title" label="发送内容"></el-table-column>
      <el-table-column prop="RealPushTime" label="发送时间"></el-table-column>
      <el-table-column prop="PushUser" label="任务添加人"></el-table-column>
      <el-table-column prop="CreatePushTime" label="任务添加时间">
        <template slot-scope="scope">{{ scope.row.CreatePushTime | handleTime }}</template>
      </el-table-column>
      <el-table-column prop="VerifyUser" label="审批人"></el-table-column>
      <el-table-column prop="VerifyTime" label="审批时间"></el-table-column>
      <el-table-column prop="Status" label="发送状态">
        <template slot-scope="scope">{{ scope.row.Status | handleStatus }}</template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="text"
            :disabled="![2, 4].includes(scope.row.Status)"
            @click="openPullBackDialog(scope.row)"
          >
            撤回
          </el-button>
          <el-button
            type="text"
            :disabled="scope.row.Status !== 1"
            @click="cancelPush(scope.row.PushId)"
          >
            取消发送
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :visible.sync="dialogPullBack" width="380px" top="10vh" title="撤回文章">
      <div class="sort-left-content">
        <el-checkbox
          :indeterminate="isIndeterminate"
          v-model="checkAll"
          :disabled="articleList.map((item) => item.Status).includes(2)"
          @change="handleCheckAllChange"
        >
          全选
        </el-checkbox>
        <el-checkbox-group v-model="checkList">
          <div v-for="(item, index) in articleList" :key="index">
            <div class="top_article" v-if="index === 0">
              <div class="flex-container">
                <el-checkbox :label="item" :disabled="item.Status === 2">
                  <span></span>
                </el-checkbox>
                <el-image :src="articleList[0].CoverUrl" @click="checkArticle(item)"></el-image>
              </div>
              <div class="top_article_title" :title="item.Title">{{ item.Title }}</div>
            </div>
            <div v-else class="article_item">
              <el-checkbox :label="item" :disabled="item.Status === 2">
                <span></span>
              </el-checkbox>
              <div class="flex-container" @click="checkArticle(item)">
                <div class="item_title" :title="item.Title">{{ item.Title }}</div>
                <el-image :src="item.CoverUrl" class="item_cover"></el-image>
              </div>
            </div>
          </div>
        </el-checkbox-group>
      </div>
      <div style="text-align: center" slot="footer">
        <el-button type="primary" @click="pullBack">撤回</el-button>
      </div>
    </el-dialog>
    <div style="text-align: right">
      <el-pagination
        style="background-color: #ffffff; width: 100%"
        layout="total, prev,sizes, pager, next, jumper"
        :total="pageTotal"
        :page-sizes="g_pageSizesConfig"
        :page-size="pageSize"
        :current-page="pageIndex"
        @current-change="changePageIndex"
        @size-change="changePageSize"
      />
    </div>
  </div>
</template>

<script>
import {
  GetArticlePushList,
  ArticlePushReallocate,
  ArticleCancelPush,
} from '@/api/releaseManagement';
export default {
  name: 'PushLine',
  filters: {
    handleType(type) {
      switch (type) {
        case 1:
          return '公众号文章';
        case 2:
          return '企业微信文章';
        default:
          return '未知';
      }
    },
    handleStatus(status) {
      switch (status) {
        case 1:
          return '等待发送';
        case 2:
          return '发送成功';
        case 3:
          return '发送失败';
        case 4:
          return '部分撤回';
        case 5:
          return '全部撤回';
        case 6:
          return '已取消';
        default:
          return '未知';
      }
    },
    handleTime(time) {
      if (time) {
        const date = new Date(time * 1000 + 8 * 3600 * 1000);
        return date.toJSON().substr(0, 19).replace('T', ' ').replace(/-/g, '.');
      }
      return '-';
    },
  },
  data() {
    return {
      tableData: [],
      pageIndex: 1,
      pageSize: 20,
      pageTotal: 1,
      tableLoading: false,

      dialogPullBack: false,
      articleList: [],
      selectedPushId: 0,
      checkList: [],
      isIndeterminate: false,
      checkAll: false,
    };
  },
  computed: {
    selectableLength() {
      let i = 0;
      this.articleList.forEach((item) => {
        if (item.Status === 1) {
          i += 1;
        }
      });
      return i;
    },
  },
  created() {
    const breadcrumb = [
      { menu_name: '发布管理', menu_path: '' },
      {
        menu_name: '内容管理',
        menu_path: '',
      },
      { menu_name: '发送任务列表' },
    ];
    this.$store.commit('user/setBreadcrumb', breadcrumb);

    this.getList();
  },
  methods: {
    getList() {
      this.tableLoading = true;
      GetArticlePushList({
        PageIndex: this.pageIndex,
        PageSize: this.pageSize,
      })
        .then((res) => {
          this.tableData = res.PushList;
          this.pageTotal = res.TotalCount;
          this.tableLoading = false;
        })
        .catch((e) => {
          this.$message.error(e);
        });
    },
    changePageIndex(val) {
      this.pageIndex = val;
      this.getList();
    },
    changePageSize(val) {
      this.pageSize = val;
      this.getList();
    },
    openPullBackDialog(row) {
      if (row.Status === 1) {
        this.$message.success('文章还未推送');
      }
      this.articleList = row.ArticleList;
      this.selectedPushId = row.PushId;
      this.checkList.splice(0, this.checkList.length);
      this.checkAll = false;
      this.isIndeterminate = false;
      this.dialogPullBack = true;
    },
    cancelPush(PushId) {
      ArticleCancelPush({ PushId })
        .then(() => {
          this.$message.success('取消推送成功！');
          this.getList();
        })
        .catch((e) => {
          this.$message.error(e);
        });
    },
    pullBack() {
      ArticlePushReallocate({
        PushId: this.selectedPushId,
        ArtId: this.checkList.map((item) => item.ArtId).join(','),
      })
        .then(() => {
          this.$message.success('撤回成功！');
          this.dialogPullBack = false;
          this.getList();
        })
        .catch((e) => {
          this.$message.error(e);
        });
    },
    checkArticle(art) {
      if (this.checkList.includes(art)) {
        this.checkList.splice(this.checkList.indexOf(art), 1);
      } else {
        this.checkList.push(art);
      }
      this.handleCheckChange();
    },
    handleCheckAllChange() {
      this.isIndeterminate = false;
      this.checkList = this.checkAll ? [...this.articleList] : [];
    },
    handleCheckChange() {
      const { length } = this.checkList;
      if (length === 0) {
        // 没选
        this.isIndeterminate = false;
        this.checkAll = false;
      } else if (length === this.selectableLength) {
        // 全选
        this.isIndeterminate = false;
        this.checkAll = true;
      } else {
        // 半选
        this.isIndeterminate = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.flex-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
.sort-left-content {
  position: relative;
  width: 296px;
  min-height: 613px;
  max-height: 700px;
  //height: 613px;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 8px;
  overflow-y: auto;
  .top_article {
    height: 195px;
    position: relative;
    cursor: pointer;
    ::v-deep.el-image {
      width: 100%;
      height: 155px;
    }
    img {
      width: 100%;
      height: 155px;
    }
    .top_article_title {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 16px;
      padding-left: 24px;
      height: 40px;
      line-height: 40px;
    }
  }
  .article_item {
    height: 61px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    padding-right: 12px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    &:hover {
      background: rgba(0, 0, 0, 0.03);
    }
    &.no_hover {
      &:hover {
        background: none !important;
      }
    }
    .item_title {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: inline-block;
      //margin: 18px 0 15px;
      margin-left: 12px;
      height: 28px;
      line-height: 28px;
      padding-right: 10px;
      font-size: 14px;
      width: 180px;
    }
    .item_cover {
      border-radius: 8px;
      //margin: 8px 0;
      height: 45px;
      width: 80px;
    }
  }
}
</style>
